import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { loadLangTranslations, SELECTED_LANG } from "./utils/translations";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    supportedLngs: ['ru', 'en'],

    interpolation: {
      escapeValue: false // react already safes from xss
    },
  });

export const loadDefaultLang = async () => {
  const earlySelectedLang = localStorage.getItem(SELECTED_LANG)
  if (earlySelectedLang) {
    await loadLangTranslations(earlySelectedLang)
    return earlySelectedLang
  }
  const lang = navigator.language.split('-')[0]
  await loadLangTranslations(lang)
  return lang
}

export default i18n;
